import * as React from "react";

type TQuizAjaxButtonProps = {
  quizUrl: string;
  onQuizLoaded: () => void;
  caseName?: string;
  timeOnCase?: string;
};

const QuizAjaxButton = ({
  quizUrl,
  onQuizLoaded,
  caseName,
  timeOnCase,
}: TQuizAjaxButtonProps) => (
  <a
    className="finish-card-button"
    href="#"
    data-url={quizUrl}
    role="button"
    aria-label="Take the quiz now"
    onClick={(e) => {
      e.preventDefault();
      fetch(quizUrl)
        .then((response) => response.text())
        .then((html) => (window as any).Turbo.renderStreamMessage(html))
        .then(() => {
          const el = document.getElementById("openQuestionContainer");
          if (el) el.classList.remove("hidden");
          if (onQuizLoaded) onQuizLoaded();
        });
    }}
  >
    <span className="finish-card-quiz-text" data-url={quizUrl}>
      Take the quiz now
    </span>
  </a>
);

export default React.memo(QuizAjaxButton);
